export function normalizePersonalizationResponse(response) {
  if (!response || !Array.isArray(response.sections)) {
    return [];
  }

  return response.sections.map((section) => ({
    section: section.section,
    items: Array.isArray(section.items) ? section.items : [],
  }));
}
